<template>
    <div class="tamanhoPopUp">
            <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>             
            <vs-row class="mb-4" vs-type="flex" vs-justify="space-between">               
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">
                    <label class="vs-input--label">{{$t("Periodo")}}</label>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="3">                
                    <flat-pickr v-model="filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
                    <label class="ml-2 mr-2 vs-input--label">à</label>
                    <flat-pickr v-model="filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
                </vs-col>                
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
                    <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
                </vs-col>
            </vs-row>
            <ag-grid-vue
                ref="agGridTable"        
                :gridOptions="configuracaoGrid.gridOptions"
                class="ag-theme-material ag-grid-table ag-grid-altura"
                :columnDefs="configuracaoGrid.columnDefs"
                :defaultColDef="configuracaoGrid.defaultColDef"
                :rowData="dadosDaGrid"
                :headerHeight="25"
                :rowHeight="25"
                :suppressHorizontalScroll="true"
                rowSelection="single"
                :rowMultiSelectWithClick="true"
                colResizeDefault="shift"
                @grid-ready="onGridReady"
                @row-selected="onRowSelectedRegistro"    
                :animateRows="true"
                :floatingFilter="false"
                :pagination="false"
                :paginationAutoPageSize="true"
                :suppressPaginationPanel="true">
            </ag-grid-vue>             
    </div>
</template>

<script>
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/concept/scss/tabelaBasica.scss'
import flatPickr from 'vue-flatpickr-component';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

const URL_SERVLET = "/ListarHistoricoControleRetornoVeiculo";

export default {    
    components: {
        AgGridVue,
        flatPickr
    }, 
    props: {       
        mensagemExplicacao: {
            type:String,
            required: false
        },        
        veiculoSelecionado: {
            type: Object,
            required: false
        } 
    },    
    data() {
        return {
            errorsValidacao: [],  
            configuracaoGrid: { 
                gridApi: null, gridColumnApi: null, gridOptions: {}, 
                defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
                columnDefs: [        
                    { headerName: 'IDENTIFICADOR', field: 'identificadoViagem', width: 200  },
                    { headerName: 'REGIÃO ATENDIDA',  field: 'regiaoAtendida' , width: 90, cellClass:'text-center', headerClass:'text-center' },                    
                    { headerName: 'PREVISÃO',  field: 'poiSaidaNome', width: 120 , valueGetter: function(params) { return params.data.dataPrevistaSaida + '\n' +  params.data.dataPrevistaRetorno} },
                    { headerName: 'REALIZADO',  field: 'poiRetornoNome', width: 120, valueGetter: function(params) { return params.data.dataRealizadaSaida + '\n' +  params.data.dataRealizadaRetorno} },
                    
                ]
            },
            configDatePicker: {          
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "U", 
                altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
                locale: PortugueseLocale
            },
            dadosDaGrid: [], 
            viagemSelecionadas: [],
            filtro: {dataInicio: null, dataFim: null} 
        }
    },    
    methods: {        
        fetchLista() {      
            if (!this.formularioValido()) {
                return;
            }

            const params = new URLSearchParams();
            params.append('outputFormat', 'JSON');
            params.append('idCliente', this.$store.state.AppActiveUser.id); 
            params.append('idVeiculo', this.veiculoSelecionado.idVeiculo); 
            params.append('dataInicio', this.filtro.dataInicio*1000);
			params.append('dataFim', this.filtro.dataFim*1000);

            
            axios.post(URL_SERVLET, params, 
                    { credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) { // Efetuar logoff                    
                    this.$router.push({ path: '/login' });
                } else {
                    this.dadosDaGrid = response.data;   
                    this.configuracaoGrid.gridApi.sizeColumnsToFit();                  
                }
            })
            .catch((error) => { 
                /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - " + error);
            })                  
        },
        onRowSelectedRegistro() {                  
            this.viagemSelecionadas = null;
            this.viagemSelecionadas = [];
            let self_ = this;
            var selectedRows = this.configuracaoGrid.gridApi.getSelectedRows();
            selectedRows.forEach(function(selectedRow) {
                self_.viagemSelecionadas.push(selectedRow);
            });                
            this.$emit('selecionarViagem', this.viagemSelecionadas);            
        },
        onGridReady() {            
            this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;       
            this.configuracaoGrid.gridColumnApi = this.configuracaoGrid.gridOptions.columnApi;                    
            this.fetchLista(this.filtro);
        },
        formularioValido() {
            this.$refs.errosComponent.iniciar();
            this.errorsValidacao = [];

            if (this.filtro.dataInicio && !this.filtro.dataFim) {
                this.errorsValidacao.push("Informe a data fim");
            } 

            if (!this.filtro.dataInicio && this.filtro.dataFim) {
                this.errorsValidacao.push("Informe a data início");
            } 

            if (!this.errorsValidacao.length) {
                return true;
            }   

            return false;
      
        }        
    },
    mounted() {
    var date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.filtro.dataInicio = String(firstDay.getTime()/1000);
    this.filtro.dataFim = String(lastDay.getTime()/1000);    
  }  
}
</script>

<style lang="scss" scoped>
  .ag-grid-altura {       
    height: 340px; 
  }

  .tamanhoPopUp {
    height: 370px;       
  }  
</style>